import "./index.scss";
import * as Sentry from "@sentry/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import {
	BrowserRouter,
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType
} from "react-router-dom";
import App from "./App";
import { BrowserTracing } from "@sentry/tracing";
import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { hotjar } from "react-hotjar";

import ScrollToTop from "./components/ScrollToTop";

import Inter from "./assets/fonts/Inter-VariableFont_slnt,wght.ttf"; // eslint-disable-line no-unused-vars
import { isWpAdmin } from "./helpers/authHelpers";

if (process.env.NODE_ENV === "production") {
	if (process.env.REACT_APP_HOTJAR_ID) {
		hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, 6);
	}
} else {
	const axe = require("@axe-core/react");
	axe(React, ReactDOM, 1000); // eslint-disable-line no-magic-numbers
}

if (process.env.REACT_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		environment: process.env.REACT_APP_ENV || "local",
		integrations: [
			new BrowserTracing({
				routingInstrumentation: Sentry.reactRouterV6Instrumentation(
					React.useEffect,
					useLocation,
					useNavigationType,
					createRoutesFromChildren,
					matchRoutes
				)
			})
		],
		tracesSampleRate: process.env.REACT_APP_ENV === "production" ? 0.5 : 1.0
	});
}

if (process.env.REACT_APP_GTM) {
	const tagManagerArgs = {
		gtmId: process.env.REACT_APP_GTM
	};

	if (process.env.REACT_APP_GTM_AUTH) {
		tagManagerArgs.auth = process.env.REACT_APP_GTM_AUTH;
	}

	if (process.env.REACT_APP_GTM_PREVIEW) {
		tagManagerArgs.preview = process.env.REACT_APP_GTM_PREVIEW;
	}

	if (!isWpAdmin()) {
		TagManager.initialize(tagManagerArgs);
	}
}

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<ScrollToTop />
			<App />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);

serviceWorkerRegistration.register();
